import CrudReducer from './crudReducer';

const cr = new CrudReducer('ticker');

const reducer = cr.Reducer;

export default reducer;
